"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[497],{

/***/ 7844:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "j": function() { return /* binding */ Banner; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(72779);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _Image_Image__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(33686);
/* harmony import */ var _InternalLink_InternalLink__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(97084);





var Banner = function(param) {
    var src = param.src, name = param.name, className = param.className, href = param.href;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_InternalLink_InternalLink__WEBPACK_IMPORTED_MODULE_3__/* .InternalLink */ .h, {
        className: classnames__WEBPACK_IMPORTED_MODULE_2___default()("w-full max-h-[400px] block rounded-lg overflow-hidden", className),
        href: href !== null && href !== void 0 ? href : "",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Image_Image__WEBPACK_IMPORTED_MODULE_4__/* .Image */ .E, {
            alt: name,
            className: "w-full h-full",
            imagePositionClassName: "object-cover",
            imageProps: {
                className: "h-full w-full"
            },
            src: src
        })
    });
};


/***/ }),

/***/ 51137:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "i": function() { return /* binding */ Slider; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(70865);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(96670);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var react_slick__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(23467);
/* harmony import */ var slick_carousel_slick_slick_css__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(62416);
/* harmony import */ var slick_carousel_slick_slick_css__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(slick_carousel_slick_slick_css__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var slick_carousel_slick_slick_theme_css__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(57142);
/* harmony import */ var slick_carousel_slick_slick_theme_css__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(slick_carousel_slick_slick_theme_css__WEBPACK_IMPORTED_MODULE_4__);







var sliderSettings = {
    arrows: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    vertical: false,
    dots: true
};
var styles = "\n.dots {\n  display: flex !important;\n  justify-content: center;\n  margin-top: 18px;\n  width: 100%;\n  justify-content: center;\n  \n}\n\n.dots>li {\n  flex: 1 1 0px;\n  margin: 0 10px;\n  max-width: 50px;\n}\n\n.dots>li>button {\n  margin: 0 12px;\n  height: 4px;\n  background: #E5E7EB;\n  color: transparent;\n  width: 100%;\n}\n\n.dots>li.slick-active>button {\n  background: #afafaf;\n}\n";
var Slider = function(param) {
    var children = param.children;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_slick__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, sliderSettings), {
                className: "w-full",
                dotsClass: "dots",
                children: children
            })),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("style", {
                children: styles
            })
        ]
    });
};


/***/ }),

/***/ 21497:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "e": function() { return /* binding */ ShopCollection; }
});

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(70865);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(96670);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../@core-shop/types/index.ts + 2 modules
var types = __webpack_require__(90195);
// EXTERNAL MODULE: ../@shared/utils/routes.tsx + 2 modules
var routes = __webpack_require__(89117);
// EXTERNAL MODULE: ../@shared-tailwind/atoms/Loader/Loader.tsx
var Loader = __webpack_require__(87864);
// EXTERNAL MODULE: ../@shared-tailwind/atoms/InternalLink/InternalLink.tsx
var InternalLink = __webpack_require__(97084);
// EXTERNAL MODULE: ../@shared-tailwind/molecules/HeadingSection/HeadingSection.tsx
var HeadingSection = __webpack_require__(22562);
// EXTERNAL MODULE: ../@shared/utils/pluralize.tsx
var pluralize = __webpack_require__(54857);
// EXTERNAL MODULE: ../../node_modules/classnames/index.js
var classnames = __webpack_require__(72779);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_extends.mjs
var _extends = __webpack_require__(58013);
// EXTERNAL MODULE: ../../node_modules/@heroicons/react/outline/esm/ChatAltIcon.js
var ChatAltIcon = __webpack_require__(4084);
// EXTERNAL MODULE: ../@shared-tailwind/types/buttons.ts
var buttons = __webpack_require__(49614);
// EXTERNAL MODULE: ../@shared-tailwind/atoms/Button/Button.tsx
var Button = __webpack_require__(2150);
;// CONCATENATED MODULE: ../@shared-tailwind/atoms/ChatButton/ChatButton.tsx








var ChatButton = function(_param) {
    var props = (0,_extends/* default */.Z)({}, _param);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
        resetSizeClasses: true,
        className: "px-2 py-1",
        Icon: ChatAltIcon/* default */.Z,
        iconClassName: "text-primary-500 w-5 h-5",
        size: buttons/* ButtonSizes.xs */.P.xs,
        variant: Button/* ButtonVariants.secondary */.c.secondary
    }));
};

// EXTERNAL MODULE: ../@shared-tailwind/atoms/Image/Image.tsx + 1 modules
var Image = __webpack_require__(33686);
;// CONCATENATED MODULE: ../@shared-tailwind/atoms/LinkBlock/LinkBlock.tsx






var LinkBlock = function(param) {
    var className = param.className, imageSrc = param.imageSrc, brandName = param.brandName, givesSubTitle = param.givesSubTitle, givesTitle = param.givesTitle, isRounded = param.isRounded, promotionText = param.promotionText, isFeatured = param.isFeatured, bgColor = param.bgColor, href = param.href;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(InternalLink/* InternalLink */.h, {
        shallow: true,
        className: classnames_default()("bg-white", isFeatured ? "w-[230px] text-left" : "w-[155px] text-center", className),
        href: href !== null && href !== void 0 ? href : "",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* Image */.E, {
                alt: brandName,
                className: classnames_default()(isFeatured ? "h-[150px]" : "h-[116px]"),
                imagePositionClassName: "object-contain",
                imageProps: {
                    className: classnames_default()("h-full w-full", isRounded && "rounded-lg"),
                    style: {
                        background: bgColor
                    }
                },
                src: imageSrc
            }),
            promotionText && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: classnames_default()("w-full text-center bg-deals-500 relative -top-5 -mb-5", "text-gray-900 text-[11px] h-5 leading-5 uppercase"),
                children: promotionText
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: classnames_default()("text-gray-900 leading-6 p-4", isFeatured && "pr-10"),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "w-full text-gray-500 text-xs line-clamp-2 h-8",
                        children: brandName
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                        className: "w-full relative",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: givesTitle
                            }),
                            isFeatured && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "absolute -right-6 top-0",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ChatButton, {})
                            })
                        ]
                    }),
                    givesSubTitle && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "w-full text-xs line-clamp-2",
                        children: givesSubTitle
                    })
                ]
            })
        ]
    });
};

// EXTERNAL MODULE: ../@shared-tailwind/molecules/BlocksCarousel/BlocksCarousel.tsx
var BlocksCarousel = __webpack_require__(740);
;// CONCATENATED MODULE: ../@shared-tailwind/organisms/ShopCollections/Carousel.tsx





var GridView = function(param) {
    var children = param.children;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "grid gap-4 grid-cols-2 sm:grid-cols-3",
        children: children
    });
};
var Carousel = function(param) {
    var links = param.links, isGrid = param.isGrid;
    var Wrapper = (0,react.useMemo)(function() {
        return isGrid ? GridView : BlocksCarousel/* BlocksCarousel */.Y;
    }, [
        isGrid
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Wrapper, {
        rows: 2,
        children: links.map(function(param) {
            var giveSentence = param.giveSentence, linkId = param.id, images = param.images, name = param.name, giftcardType = param.giftcardType, previewInfo = param.previewInfo;
            var ref;
            var topDeal = (ref = previewInfo.topPromotionInfo) === null || ref === void 0 ? void 0 : ref.link;
            var promotionsText;
            if (topDeal === null || topDeal === void 0 ? void 0 : topDeal.giveSentence) promotionsText = topDeal.giveSentence;
            if (previewInfo.promotionsCount - 1 && promotionsText) promotionsText += " + ".concat((0,pluralize/* pluralize */._)(" deal", previewInfo.promotionsCount - 1));
            var _image;
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(LinkBlock, {
                brandName: name,
                givesTitle: giveSentence,
                href: routes/* shopcloud.linkModal */.nR.linkModal(linkId),
                imageSrc: (_image = images.image) !== null && _image !== void 0 ? _image : "",
                isRounded: giftcardType === "Gift Card",
                promotionText: promotionsText
            }, linkId);
        })
    });
};

// EXTERNAL MODULE: ../@shared/utils/getUrlFromAssetDestination.ts
var getUrlFromAssetDestination = __webpack_require__(85179);
// EXTERNAL MODULE: ../@shared-tailwind/atoms/Slider/Slider.tsx
var Slider = __webpack_require__(51137);
// EXTERNAL MODULE: ../@shared-tailwind/atoms/Banner/Banner.tsx
var Banner = __webpack_require__(7844);
;// CONCATENATED MODULE: ../@shared-tailwind/organisms/ShopCollections/BannerCarousel.tsx




var BannerCarousel = function(param) {
    var assets = param.assets;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Slider/* Slider */.i, {
        children: assets.map(function(param) {
            var asset = param.asset;
            var ref, ref1;
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Banner/* Banner */.j, {
                className: "aspect-[12/9]",
                href: (0,getUrlFromAssetDestination/* getUrlFromAssetDestination */.m)((ref = asset === null || asset === void 0 ? void 0 : asset.destination) !== null && ref !== void 0 ? ref : "").toString(),
                name: "",
                src: (ref1 = asset === null || asset === void 0 ? void 0 : asset.small) !== null && ref1 !== void 0 ? ref1 : ""
            }, asset === null || asset === void 0 ? void 0 : asset.small);
        })
    });
};

// EXTERNAL MODULE: ../@shared-tailwind/atoms/BaseBrandBlock/BaseBrandBlock.tsx
var BaseBrandBlock = __webpack_require__(47070);
;// CONCATENATED MODULE: ../@shared-tailwind/atoms/BrandCard/BrandCard.tsx






var BrandCard = function(param) {
    var className = param.className, imageSrc = param.imageSrc, brandName = param.brandName, givesTitle = param.givesTitle, isFeatured = param.isFeatured, isLiked = param.isLiked, href = param.href, bgColor = param.bgColor, brandId = param.brandId, toggleFavioriteMutation = param.toggleFavioriteMutation;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: classnames_default()("rounded-lg border bg-white", isFeatured ? "w-[230px] text-left" : "h-[200px] w-[155px] text-center", className),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(InternalLink/* InternalLink */.h, {
                href: href !== null && href !== void 0 ? href : "",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* Image */.E, {
                    alt: brandName,
                    className: classnames_default()(isFeatured ? "h-[170px]" : "h-[116px]"),
                    imagePositionClassName: "object-contain",
                    imageProps: {
                        className: classnames_default()("h-full w-full rounded-t-lg"),
                        style: {
                            background: bgColor
                        }
                    },
                    src: imageSrc
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "p-3",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BaseBrandBlock/* BaseBrandBlock */.x, {
                    buttonText: "Shop",
                    className: "w-full",
                    giveAmount: {
                        giveSentence: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: classnames_default()(isFeatured ? "text-lg" : "text-base"),
                            children: givesTitle
                        })
                    },
                    hasButton: false,
                    hasLikeButton: isFeatured,
                    hasLogo: false,
                    id: brandId,
                    isLiked: isLiked,
                    title: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "text-sm text-gray-500 line-clamp-1",
                        children: brandName
                    }),
                    onToggleFavoriteMutation: toggleFavioriteMutation
                })
            })
        ]
    });
};

// EXTERNAL MODULE: ../@shared-tailwind/atoms/HorizontalScroll/HorizontalScroll.tsx
var HorizontalScroll = __webpack_require__(87782);
;// CONCATENATED MODULE: ../@shared-tailwind/molecules/FeaturedCarousel/FeaturedCarousel.tsx




var FeaturedCarousel = function(param) {
    var children = param.children, className = param.className, scrollContainerClassName = param.scrollContainerClassName, bgImage = param.bgImage, title = param.title;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: classnames_default()("w-full overflow-x-hidden  pl-4 pb-4 md:pb-9", !bgImage && "bg-primary-50", className),
        style: {
            background: bgImage ? "no-repeat url(".concat(bgImage, ") center") : "",
            backgroundSize: "100%"
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                className: "w-full text-center text-xl md:text-3xl py-16",
                children: title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(HorizontalScroll/* HorizontalScroll */.Z, {
                hasCenteredItems: true,
                className: scrollContainerClassName,
                children: children
            })
        ]
    });
};

;// CONCATENATED MODULE: ../@shared-tailwind/organisms/ShopCollections/Featured.tsx





var Featured = function(param) {
    var links = param.links, collectionName = param.collectionName, toggleFavioriteMutation = param.toggleFavioriteMutation;
    var _image;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(FeaturedCarousel, {
        title: collectionName !== null && collectionName !== void 0 ? collectionName : "Featured",
        children: links.map(function(param, i) {
            var giveSentence = param.giveSentence, linkId = param.id, images = param.images, name = param.name, defaultBrand = param.defaultBrand;
            /*#__PURE__*/ return (0,jsx_runtime.jsx)(BrandCard, {
                brandId: defaultBrand === null || defaultBrand === void 0 ? void 0 : defaultBrand.id,
                brandName: name,
                givesTitle: giveSentence,
                href: routes/* shopcloud.linkModal */.nR.linkModal(linkId),
                imageSrc: (_image = images.image) !== null && _image !== void 0 ? _image : "",
                isFeatured: i === 0,
                toggleFavioriteMutation: toggleFavioriteMutation
            }, linkId);
        })
    });
};

// EXTERNAL MODULE: ../@shared-tailwind/atoms/BrandBlock/BrandBlock.tsx
var BrandBlock = __webpack_require__(9079);
;// CONCATENATED MODULE: ../@shared-tailwind/organisms/ShopCollections/BrandsCarousel.tsx





var BrandsCarousel_GridView = function(param) {
    var children = param.children;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "grid gap-6 grid-cols-1",
        children: children
    });
};
var BrandsCarousel = function(param) {
    var brands = param.brands, isGrid = param.isGrid, toggleFavioriteMutation = param.toggleFavioriteMutation, shouldShowLikeButton = param.shouldShowLikeButton;
    var Wrapper = (0,react.useMemo)(function() {
        return isGrid ? BrandsCarousel_GridView : BlocksCarousel/* BlocksCarousel */.Y;
    }, [
        isGrid
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Wrapper, {
        rows: 3,
        children: brands === null || brands === void 0 ? void 0 : brands.map(function(param) {
            var id = param.id, images = param.images, maxGiveLink = param.maxGiveLink, name = param.name, isLiked = param.viewerHasFavorited;
            /*#__PURE__*/ return (0,jsx_runtime.jsx)(BrandBlock/* BrandBlock */.s, {
                bgColor: images.logoBackgroundColor,
                buttonText: "Shop",
                buttonUrl: routes/* shopcloud.brandModal */.nR.brandModal(id),
                givesTitle: maxGiveLink === null || maxGiveLink === void 0 ? void 0 : maxGiveLink.giveSentence,
                hasLikeButton: shouldShowLikeButton,
                id: id,
                imageSrc: images.invertedLogo || images.logo || "",
                isLiked: isLiked,
                name: name,
                onToggleFavoriteMutation: toggleFavioriteMutation
            }, id);
        })
    });
};

// EXTERNAL MODULE: ../@shared-tailwind/atoms/Department/Department.tsx
var Department = __webpack_require__(19624);
;// CONCATENATED MODULE: ../@shared-tailwind/organisms/ShopCollections/Departments.tsx





var Departments_GridView = function(param) {
    var children = param.children;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "grid gap-2 grid-cols-3",
        children: children
    });
};
var Departments = function(param) {
    var assets = param.assets, isGrid = param.isGrid;
    var Wrapper = (0,react.useMemo)(function() {
        return isGrid ? Departments_GridView : HorizontalScroll/* HorizontalScroll */.Z;
    }, [
        isGrid
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Wrapper, {
        children: assets.map(function(param) {
            var title = param.title, asset = param.asset;
            var ref, ref1;
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Department/* Department */.y, {
                className: classnames_default()(isGrid ? "w-full" : "w-[136px]"),
                href: (0,getUrlFromAssetDestination/* getUrlFromAssetDestination */.m)((ref = asset === null || asset === void 0 ? void 0 : asset.destination) !== null && ref !== void 0 ? ref : "").toString(),
                imageSrc: (ref1 = asset === null || asset === void 0 ? void 0 : asset.small) !== null && ref1 !== void 0 ? ref1 : "",
                name: title
            }, asset === null || asset === void 0 ? void 0 : asset.small);
        })
    });
};

;// CONCATENATED MODULE: ../@shared-tailwind/organisms/ShopCollection/ShopCollection.tsx










var CAROUSEL = types/* CollectionStyle.CAROUSEL */.a8.CAROUSEL, BANNER_CAROUSEL = types/* CollectionStyle.BANNER_CAROUSEL */.a8.BANNER_CAROUSEL, DEPARTMENT_GRID = types/* CollectionStyle.DEPARTMENT_GRID */.a8.DEPARTMENT_GRID, FEATURED = types/* CollectionStyle.FEATURED */.a8.FEATURED, BRAND_CAROUSEL = types/* CollectionStyle.BRAND_CAROUSEL */.a8.BRAND_CAROUSEL;
var COLLECTIONS_HAS_SEE_ALL = [
    CAROUSEL,
    DEPARTMENT_GRID,
    BRAND_CAROUSEL
];
var COLLECTIONS_NO_HEADER = [
    FEATURED,
    BANNER_CAROUSEL
];
var ShopCollection = function(param) {
    var collection = param.collection, _hasTitle = param.hasTitle, hasTitle = _hasTitle === void 0 ? true : _hasTitle, collectionQuery = param.collectionQuery, isGrid = param.isGrid, toggleFavoriteMutation = param.toggleFavoriteMutation, shouldShowLikeButton = param.shouldShowLikeButton;
    var ref = collection !== null && collection !== void 0 ? collection : {}, style = ref.style, links = ref.links, collectionName = ref.name, assets = ref.assets, id = ref.id, brands = ref.brands;
    var CollectionComponent = (0,react.useMemo)(function() {
        var Component = null;
        switch(style){
            case CAROUSEL:
                {
                    if (!(links === null || links === void 0 ? void 0 : links.length)) return null;
                    Component = function(props) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Carousel, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
                            isGrid: isGrid
                        }));
                    };
                    break;
                }
            case BANNER_CAROUSEL:
                {
                    if (!(assets === null || assets === void 0 ? void 0 : assets.length)) return null;
                    Component = BannerCarousel;
                    break;
                }
            case FEATURED:
                {
                    if (!links) return null;
                    Component = Featured;
                    break;
                }
            case DEPARTMENT_GRID:
                {
                    if (!(assets === null || assets === void 0 ? void 0 : assets.length)) return null;
                    Component = function(props) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Departments, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
                            isGrid: isGrid
                        }));
                    };
                    break;
                }
            case BRAND_CAROUSEL:
                {
                    if (!(brands === null || brands === void 0 ? void 0 : brands.length)) return null;
                    Component = function(props) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(BrandsCarousel, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
                            isGrid: isGrid
                        }));
                    };
                    break;
                }
            default:
                {
                    break;
                }
        }
        return Component;
    }, [
        assets === null || assets === void 0 ? void 0 : assets.length,
        brands === null || brands === void 0 ? void 0 : brands.length,
        isGrid,
        links,
        style
    ]);
    if (!style) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "w-full mb-10",
        children: [
            (collectionQuery === null || collectionQuery === void 0 ? void 0 : collectionQuery.isLoading) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "w-full py-10 flex justify-center",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Loader/* Loader */.a, {
                    size: 96
                })
            }),
            !!CollectionComponent && hasTitle && !COLLECTIONS_NO_HEADER.includes(style) && /*#__PURE__*/ (0,jsx_runtime.jsx)(HeadingSection/* HeadingSection */.R, {
                hasNoBorder: true,
                shouldForceOneLine: true,
                Buttons: COLLECTIONS_HAS_SEE_ALL.includes(style) && /*#__PURE__*/ (0,jsx_runtime.jsx)(InternalLink/* InternalLink */.h, {
                    className: "text-primary-500 pb-2 whitespace-nowrap",
                    href: routes/* shopcloud.collection */.nR.collection({
                        id: id
                    }),
                    children: "See All"
                }),
                children: collectionName
            }),
            CollectionComponent && /*#__PURE__*/ (0,jsx_runtime.jsx)(CollectionComponent, {
                assets: assets,
                brands: brands,
                isGrid: !!isGrid,
                links: links,
                shouldShowLikeButton: shouldShowLikeButton,
                toggleFavioriteMutation: toggleFavoriteMutation
            })
        ]
    }, id);
};


/***/ }),

/***/ 85179:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "m": function() { return /* binding */ getUrlFromAssetDestination; }
/* harmony export */ });
/* harmony import */ var _routes__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(89117);

var destKeys = {
    storefront: "StoreFront::",
    url: "URL::",
    brand: "Brand::",
    link: "Link::",
    collection: "Collection::"
};
function getUrlFromAssetDestination(dest) {
    if (dest.includes(destKeys.storefront)) return _routes__WEBPACK_IMPORTED_MODULE_0__/* .shopcloud.storefront */ .nR.storefront({
        id: dest.replace(destKeys.storefront, "")
    });
    if (dest.includes(destKeys.url)) return dest.replace(destKeys.url, "");
    if (dest.includes(destKeys.brand)) return _routes__WEBPACK_IMPORTED_MODULE_0__/* .shopcloud.brandModal */ .nR.brandModal(dest.replace(destKeys.brand, ""));
    if (dest.includes(destKeys.link)) return _routes__WEBPACK_IMPORTED_MODULE_0__/* .shopcloud.linkModal */ .nR.linkModal(dest.replace(destKeys.link, ""));
    if (dest.includes(destKeys.collection)) return _routes__WEBPACK_IMPORTED_MODULE_0__/* .shopcloud.collection */ .nR.collection({
        id: dest.replace(destKeys.collection, "")
    });
    return dest;
}


/***/ })

}]);